import React, { useMemo } from "react";
import { View } from "react-native";
import { useI18n } from "@lookiero/i18n-react";
import { QuestionItem, QuestionType } from "@lookiero/sty-psp-quiz-style-profile-common-ui";
import { Text } from "@lookiero/sty-psp-ui";
import { DOMAIN } from "../../../../i18n/i18n";
import { style as hostDefaultQuestionItemStyle } from "./HostDefaultQuestionItem.style";

const HostDefaultQuestionItem: QuestionItem<QuestionType.HOST_DEFAULT> = ({ question, children, segment }) => {
  const { formatMessage } = useI18n({ domain: DOMAIN });
  const title = question.translationKey
    ? formatMessage({ id: question.translationKey }, { segment: segment.toLowerCase() })
    : null;

  const style = useMemo(() => hostDefaultQuestionItemStyle(), []);

  return (
    <View style={Boolean(title) && style.questionGroup} testID="host-default-question-item">
      {title && (
        <Text level={2} style={style.title} variant="action">
          {title}
        </Text>
      )}
      {children}
    </View>
  );
};

export { HostDefaultQuestionItem };
